import { shipmentAffPrepareValidate } from '../../application/dtos/shipment_aff_prepare_validate'

export class ShipmentAffPrepareEntity {
    constructor({transaction_id, warehouse_id, operator_id, total_orders, locations}){
        this.transaction_id = transaction_id;
        this.warehouse_id = warehouse_id;
        this.operator_id = operator_id;
        this.total_orders = total_orders;
        this.locations = locations;
    }

    isValid() {
        return shipmentAffPrepareValidate(this);
    }
}